import { useState, useRef } from "react";

import clsx from "clsx";

import { MenuIcon } from "assets/icons";
import { useOutsideClick } from "hooks/useOutsideClick";

function Menu({ options, side, message, alwaysVisible, classNames }) {
  const [showMenu, setShowMenu] = useState(false);
  const ref = useRef();
  useOutsideClick(ref, () => {
    setShowMenu(false);
  });

  const handleClickItem = (handler) => () => {
    setShowMenu(false);
    handler(message);
  };

  return (
    <div
      ref={ref}
      className={`conv__body__body__inner__msg${side}__inner__menu`}
    >
      <div
        onClick={() => {
          setShowMenu((prev) => !prev);
        }}
        className={`conv__body__body__inner__msg${side}__inner__menu__btn`}
        data-show={showMenu || alwaysVisible}
      >
        <img src={MenuIcon} alt="menu" />
      </div>

      <div
        data-show={showMenu}
        className={clsx(
          `conv__body__body__inner__msg${side}__inner__menu__body`,
          classNames?.["body"]
        )}
      >
        {options.map((op, index) => {
          return (
            <div key={op.id} className="box_item_wrapper">
              <div
                className={`conv__body__body__inner__msg${side}__inner__menu__box__item`}
                key={index}
                onClick={handleClickItem(op.handler)}
              >
                <span
                  style={{
                    width: "max-content",
                  }}
                >
                  {op.text}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Menu;
